<ng-container *finLet="tierPointsCurrentPeriod$ | async as tierPoints">
  <h2>{{ 'LOYALTY.milestones.title' | finLocalization }}</h2>

  <div class="flex mr-medium-t">
    <fcom-icon class="icon-large flex--nogrow ms-medium-r" [name]="SvgLibraryIcon.MILESTONE"></fcom-icon>

    <div
      [innerHTML]="'LOYALTY.milestones.description' | finLocalization | finSafe: 'html'"
      class="flex-1 font-body-1 regular-type markup-links"
    ></div>
  </div>

  <fcom-notification
    *ngFor="let newUnlockedMilestone of newUnlockedMilestones$ | async"
    class="mr-medium-t"
    (closeClick)="dismissMilestones(tierPoints)"
    [isClosable]="true"
    [iconName]="SvgLibraryIcon.LOCK_OPEN"
    [theme]="NotificationTheme.SUCCESS"
  >
    {{ newUnlockedMilestone | finStripHtml }}
  </fcom-notification>

  <div class="milestones flex flex--wrap mr-medium-t">
    <fin-milestone
      *ngFor="let milestone of milestoneItems$ | async; trackBy: trackByFn"
      [content]="milestone"
      [tierPointsCurrentPeriod]="tierPoints"
    />
  </div>
</ng-container>
